import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "../store/store";

export type SharedPersonalDetailsState = {
  firstName: string;
  lastName: string;
  mobileNumber: {
    countryCode: string;
    countryCodeIso: string;
    number: string;
  };
  email: string;
  partnerCode: string;
  friendsAndFamilyContact: string;
  marketingConsent: "yes" | "no";
};

export const defaultSharedPersonalDetailsState: SharedPersonalDetailsState = {
  firstName: "",
  lastName: "",
  mobileNumber: {
    countryCode: "971",
    countryCodeIso: "AE",
    number: "",
  },
  email: "",
  partnerCode: "",
  friendsAndFamilyContact: "",
  marketingConsent: "no",
};

export function isSharedPersonalDetailsComplete(
  value: SharedPersonalDetailsState | null | undefined
) {
  if (!value) {
    return false;
  }

  return Boolean(
    value.firstName.trim() &&
    value.lastName.trim() &&
    value.email.trim() &&
    value.mobileNumber.countryCode.trim() &&
    value.mobileNumber.number.trim()
  );
}

const personalDetailsSlice = createSlice({
  name: "sharedPersonalDetails",
  initialState: defaultSharedPersonalDetailsState,
  reducers: {
    setSharedPersonalDetails(state, action: PayloadAction<SharedPersonalDetailsState>) {
      return action.payload;
    },
    clearSharedPersonalDetails() {
      return defaultSharedPersonalDetailsState;
    },
  },
});

export const { setSharedPersonalDetails, clearSharedPersonalDetails } =
  personalDetailsSlice.actions;

export const selectSharedPersonalDetails = (state: RootState) => state.sharedPersonalDetails;

export default personalDetailsSlice.reducer;
